/**
 * Black Matte VTC - Payment Service
 * All payment-related API calls
 * NO business logic - pure API calls only
 */

import apiClient from './apiClient';

export const paymentService = {
  /**
   * Create Stripe payment session
   * @param {Object} paymentData - Payment details
   * @returns {Promise<Object>} Stripe session response
   */
  async createStripeSession(paymentData) {
    return apiClient.post('/api/payments/create-session', {
      pickup_address: paymentData.pickupAddress,
      destination_address: paymentData.destinationAddress,
      date: paymentData.date,
      time: paymentData.time,
      passengers: paymentData.passengers,
      phone: paymentData.phone,
      email: paymentData.email,
      first_name: paymentData.firstName,
      last_name: paymentData.lastName,
      customer_name: paymentData.customerName,
      notes: paymentData.notes,
      flight_number: paymentData.flightNumber,
      pickup_lat: paymentData.pickupLat,
      pickup_lng: paymentData.pickupLng,
      destination_lat: paymentData.destinationLat,
      destination_lng: paymentData.destinationLng,
      origin_url: window.location.origin,
      accepted_terms: paymentData.acceptedTerms,
      // SC-PR-5: customer-widget presentation tier ("eco" / "van" /
      // "business" / "priority"). Pre-SC-PR-5 this was dropped at this
      // layer, causing the Stripe Checkout amount to diverge from the
      // widget-displayed tier price (63 € widget vs 42 € Stripe for
      // VAN). Sending it here is the first link in the SC-PR-5 chain
      // (frontend → API schema → prepare_payment multiplier → Stripe).
      service_type: paymentData.serviceType,
    });
  },

  /**
   * Get payment status
   * @param {string} sessionId - Payment session ID
   * @returns {Promise<Object>} Payment status
   */
  async getPaymentStatus(sessionId) {
    return apiClient.get(`/api/payments/status/${sessionId}`);
  },

  /**
   * Process enterprise payment
   * @param {Object} paymentData - Payment details
   * @returns {Promise<Object>} Payment response
   */
  async processEnterprisePayment(paymentData) {
    return apiClient.post('/api/corporate/book-ride', paymentData);
  },
};

export default paymentService;
